const securityAssets = {
  stats: [
    {
      id: 0,
      stat: '99.98%',
      title: 'Uptime SLA',
      copy:
        'Our distributed infrastructure means you get the best and most reliable experience possible, no matter where your business is located',
    },
    {
      id: 1,
      stat: '24/7',
      title: 'Support',
      copy:
        'Our global support team covers each timezone, with escalation procedures​ to ensure that urgent issues are swiftly resolved',
    },
    {
      id: 2,
      stat: 'GDPR',
      title: 'Compliant',
      copy:
        'Marvel is fully commited to meeting our legal obligation with the latest GDPR regulation and protecting the data rights of our customers',
    },
  ],
};

export default securityAssets;



// WEBPACK FOOTER //
// ./src/configs/caseStudies/security.js